"use strict";
exports.__esModule = true;
exports.DeliveryUnitSaleCatalogBuilder = exports.DeliveryUnitSaleCatalog = exports.DeliveryUnitInventoryCatalog = void 0;
var PricingCatalog_1 = require("../base/PricingCatalog");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var DeliveryUnitInventoryCatalog = /** @class */ (function () {
    function DeliveryUnitInventoryCatalog() {
    }
    DeliveryUnitInventoryCatalog.getAllPieceIds = function (deliveryUnitInventoryCatalog) {
        return Array.from(new Set(deliveryUnitInventoryCatalog.pieceInventorys.map(function (p) {
            return p.pieceReference.pieceId;
        })));
    };
    DeliveryUnitInventoryCatalog.getAllAccessoryIds = function (deliveryUnitInventoryCatalog) {
        return Array.from(new Set(deliveryUnitInventoryCatalog.accessoryInventorys.map(function (p) {
            return p.accessoryReference.accessoryId;
        })));
    };
    return DeliveryUnitInventoryCatalog;
}());
exports.DeliveryUnitInventoryCatalog = DeliveryUnitInventoryCatalog;
var DeliveryUnitSaleCatalog = /** @class */ (function () {
    function DeliveryUnitSaleCatalog() {
    }
    DeliveryUnitSaleCatalog.isPublished = function (deliveryUnitSaleCatalog) {
        return DeliveryUnitSaleCatalog.isReadOnly(deliveryUnitSaleCatalog);
    };
    DeliveryUnitSaleCatalog.isReadOnly = function (deliveryUnitSaleCatalog) {
        return deliveryUnitSaleCatalog.publishedAt !== undefined && deliveryUnitSaleCatalog.publishedAt !== null;
    };
    return DeliveryUnitSaleCatalog;
}());
exports.DeliveryUnitSaleCatalog = DeliveryUnitSaleCatalog;
var DeliveryUnitSaleCatalogBuilder = /** @class */ (function () {
    function DeliveryUnitSaleCatalogBuilder(deliverUnitSaleCatalog) {
        this.deliveryUnitSaleCatalog = deliverUnitSaleCatalog;
    }
    DeliveryUnitSaleCatalogBuilder.initialiseWithDeliveryUnitSaleCatalog = function (deliverUnitSaleCatalog) {
        return new DeliveryUnitSaleCatalogBuilder(deliverUnitSaleCatalog);
    };
    DeliveryUnitSaleCatalogBuilder.initialise = function (producerPartyId, deliveryUnitId, name, description) {
        return DeliveryUnitSaleCatalogBuilder.initialiseWithDeliveryUnitSaleCatalog({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: producerPartyId,
            deliveryUnitId: deliveryUnitId,
            name: name,
            description: description,
            pricingCatalogs: [],
            inventoryCatalog: {
                accessoryInventorys: [],
                pieceInventorys: []
            },
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    DeliveryUnitSaleCatalogBuilder.prototype.build = function () {
        return this.deliveryUnitSaleCatalog;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.buildUpdate = function () {
        return {
            partyId: this.deliveryUnitSaleCatalog.partyId,
            deliveryUnitId: this.deliveryUnitSaleCatalog.deliveryUnitId,
            name: this.deliveryUnitSaleCatalog.name,
            description: this.deliveryUnitSaleCatalog.description,
            pricingCatalogs: this.deliveryUnitSaleCatalog.pricingCatalogs,
            inventoryCatalog: this.deliveryUnitSaleCatalog.inventoryCatalog,
            publishedAt: this.deliveryUnitSaleCatalog.publishedAt
        };
    };
    DeliveryUnitSaleCatalogBuilder.prototype.getId = function () {
        return this.deliveryUnitSaleCatalog.id;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.withName = function (newName) {
        this.deliveryUnitSaleCatalog.name = newName;
        return this;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.withDescription = function (newDescription) {
        this.deliveryUnitSaleCatalog.description = newDescription;
        return this;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.withId = function (id) {
        this.deliveryUnitSaleCatalog.id = id;
        return this;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.withInventoryCatalog = function (inventoryCatalog) {
        this.deliveryUnitSaleCatalog.inventoryCatalog = inventoryCatalog;
        return this;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.withPricingCatalogs = function (newPricingCatalogs) {
        this.deliveryUnitSaleCatalog.pricingCatalogs = newPricingCatalogs;
        return this;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.replaceAccessoryPricingByCurrency = function (newAccessoryPrices) {
        this.deliveryUnitSaleCatalog.pricingCatalogs = PricingCatalog_1.PricingCatalog.replaceAccessoryPricingByCurrencyInCatalogs(this.deliveryUnitSaleCatalog.pricingCatalogs, newAccessoryPrices);
        return this;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.replacePiecePricingByCurrency = function (newPiecePrices) {
        this.deliveryUnitSaleCatalog.pricingCatalogs = PricingCatalog_1.PricingCatalog.replacePiecePricingByCurrencyInCatalogs(this.deliveryUnitSaleCatalog.pricingCatalogs, newPiecePrices);
        return this;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.withPublishedAt = function (publishedAt) {
        this.deliveryUnitSaleCatalog.publishedAt = publishedAt;
        return this;
    };
    DeliveryUnitSaleCatalogBuilder.prototype.withNotPublishedAt = function () {
        return this.withPublishedAt(undefined);
    };
    return DeliveryUnitSaleCatalogBuilder;
}());
exports.DeliveryUnitSaleCatalogBuilder = DeliveryUnitSaleCatalogBuilder;
